import * as React from 'react'
import * as styles from '../styles/index.scss'
import integralModalIcon from '@assets/img/integral/integral-modal-icon.png'
import DelImg from '@assets/img/active-del.png'
import {enumToView} from '@src/utils';

export default class SignInSuccessModal extends React.Component<any> {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className={styles.signInOverlay}>
                <div className={styles.modalInfoWrap}>
                    {/* <img src={DelImg} className={styles.delImg} onClick={this.props.handleClose}/> */}
                    <span className={styles.signInModalSuccessTitle}>号卡尚未激活</span>
                    <div className={styles.alreadySignInDays}>请先激活内置号卡（激活流程可参考公众号激活教程）</div>
                    <div className={styles.btn} onClick={this.props.handleClose}>我知道了</div>
                </div>
            </div>
        )
    }
}

